import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #1a1a1a 0%, #363636 100%)',
      color: '#ffffff',
      fontFamily: 'Arial, sans-serif',
      padding: '20px',
      textAlign: 'center'
    },
    heading: {
      fontSize: '8rem',
      margin: '0',
      background: 'linear-gradient(45deg, #FFD700, #FFA500)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
      fontWeight: 'bold'
    },
    subHeading: {
      fontSize: '2rem',
      marginTop: '20px',
      color: '#FFA500',
      fontWeight: 'bold'
    },
    text: {
      fontSize: '1.2rem',
      margin: '20px 0',
      maxWidth: '600px',
      lineHeight: '1.6'
    },
    quote: {
      fontSize: '1.5rem',
      fontStyle: 'italic',
      margin: '30px 0',
      padding: '20px',
      borderLeft: '4px solid #FFA500',
      maxWidth: '600px',
      backgroundColor: 'rgba(255, 255, 255, 0.1)'
    },
    button: {
      padding: '15px 30px',
      fontSize: '1.2rem',
      backgroundColor: '#FFA500',
      color: '#1a1a1a',
      border: 'none',
      borderRadius: '30px',
      cursor: 'pointer',
      textDecoration: 'none',
      transition: 'transform 0.3s ease, background-color 0.3s ease',
      marginTop: '20px',
      fontWeight: 'bold'
    },
    buttonHover: {
      backgroundColor: '#FFD700',
      transform: 'scale(1.05)'
    }
  };

  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>404</h1>
      <h2 style={styles.subHeading}>Ennada, Inga Onnum Illa!</h2>
      <p style={styles.text}>
        The page you're looking for has vanished like a mass hero in a fight scene!
      </p>
      <div style={styles.quote}>
        "En vazhi... thani vazhi!" <br />
        <span style={{ fontSize: '1rem', opacity: 0.8 }}>
          - But this path leads nowhere
        </span>
      </div>
      <Link 
        to="/"
        style={{
          ...styles.button,
          ...(isHovered ? styles.buttonHover : {})
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        Return to Home
      </Link>
    </div>
  );
}